import React, { useState, useEffect } from "react";

const Footer = () => {
  // State to control the visibility of the "Go to Top" button
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Check scroll position
  const scrollFunction = () => {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  // Scroll to top function
  const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  // Add event listener for scroll when the component mounts
  useEffect(() => {
    window.onscroll = scrollFunction;
    return () => {
      window.onscroll = null; // Cleanup the event listener on unmount
    };
  }, []);

  return (
    <footer className="w3l-footer9">
      <section className="footer-inner-main py-5">
        <div className="container py-md-3">
          <div className="right-side">
            <div className="row footer-hny-grids sub-columns">
              <div className="col-lg-4 sub-one-left">
                <h6>About</h6>
                <p className="footer-phny pe-lg-5">
                  Our school is dedicated to nurturing young minds through
                  quality education, innovation, and holistic development. We
                  provide a supportive environment where students grow
                  academically, socially, and emotionally.
                </p>
                <div className="columns-2 mt-lg-5 mt-4">
                  <ul className="social">
                    <li>
                      <a href="#facebook">
                        <span className="fab fa-facebook-f"></span>
                      </a>
                    </li>
                    <li>
                      <a href="#linkedin">
                        <span className="fab fa-linkedin-in"></span>
                      </a>
                    </li>
                    <li>
                      <a href="#twitter">
                        <span className="fab fa-twitter"></span>
                      </a>
                    </li>
                    <li>
                      <a href="#google">
                        <span className="fab fa-google-plus-g"></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4 sub-two-right">
                <h6>Our Links</h6>
                <ul>
                  <li>
                    <a href="/Home">
                      <i className="fas fa-angle-right"></i> Home
                    </a>
                  </li>
                  <li>
                    <a href="/About">
                      <i className="fas fa-angle-right"></i> About
                    </a>
                  </li>
                  <li>
                    <a href="/Services">
                      <i className="fas fa-angle-right"></i> Services
                    </a>
                  </li>
                  <li>
                    <a href="/Support">
                      <i className="fas fa-angle-right"></i> Contact
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-4 sub-one-left">
                <h6>Contact</h6>
                <ul className="social">
                  <li className="d-flex align-items-start mb-3">
                    <a
                      href="https://www.bing.com/maps/search?name=Siddhartha+High+School&trfc=&mepi=0%7E%7EEmbedded%7ELargeMapLink&FORM=MPSRPL&style=r&q=Siddhartha+High+School&ss=id.ypid%3AYN4070x252393437&ppois=17.49513816833496_78.45491790771484_Siddhartha+High+School&cp=17.500929%7E78.457872&lvl=16"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-start justify-content-start text-decoration-none me-2"
                      style={{ width: "30px", height: "30px" }}
                    >   
                      <span className="fas fa-map-marker-alt"  style={{ width: "30px", height: "30px" }}></span>
                    </a>
                    <span>
                      {" "}
                         Uttam Gardens, Algole Road, Zaheerabadm,Sangareddy Dist, Telangana , Pincode:502220
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <a
                      href="tel:+919908419299 "
                      className="d-flex align-items-center justify-content-center text-decoration-none me-2"
                      style={{ width: "30px", height: "30px" }}
                    >
                      <span className="fas fa-phone-alt"></span>
                    </a>
                    <span>+91 9908419299 </span>

                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="below-section mt-5">
            <div className="copyright-footer">
              <div className="columns text-left">
                <p>
                  © 2025 All rights reserved. Design by{" "}
                  <a
                    href="https://dmtsoft.in/#/home"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    DMT SOFT
                  </a>
                </p>
              </div>
              <ul className="footer-w3list text-right">
                <li>
                  <a href="#url">Privacy Policy</a>
                </li>
                <li>
                  <a href="#url">Terms &amp; Conditions</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Scroll to top button */}
      {showScrollButton && (
        <button onClick={topFunction} id="movetop" title="Go to top">
          <span className="fas fa-level-up-alt" aria-hidden="true"></span>
        </button>
      )}
    </footer>
  );
};

export default Footer;
